/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:3a7a27e6-bc05-491a-97e6-a4e930f57369",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_vqmExgFJh",
    "aws_user_pools_web_client_id": "3bqmvlebralp8sjheobqfe4jes",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "nobleacquisitions5dd1ea12f0224e319c8bebad4c2ec9c3c0f-prd",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
